import { render } from "./Login.vue?vue&type=template&id=06fa25f6&scoped=true&lang=pug"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"

import "./Login.vue?vue&type=style&index=0&id=06fa25f6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-06fa25f6"

export default script